import React from "react";
import clsx from "clsx";
import { X } from "lucide-react";
import "./style.css";

interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  allowClear?: boolean;
  onClear?: () => void;
}

// Box model, palette and focus ring follow the smart-solution app's text
// input (.inputBox-1): slate border, 8px radius, blue focus ring from the
// shared --focusRing tokens. Styles live in input/style.css (.uiInput-*).
export default function Input({
  label,
  error,
  leftIcon,
  rightIcon,
  allowClear = false,
  onClear,
  className,
  value,
  ...props
}: InputProps) {
  const hasValue = !!value;

  return (
    <div className="uiInput">
      {label && <label className="uiField-label">{label}</label>}

      <div className="uiInput-wrap">
        {leftIcon && <span className="uiInput-icon uiInput-icon--left">{leftIcon}</span>}

        <input
          value={value}
          className={clsx(
            "uiInput-control",
            leftIcon && "has-left",
            (allowClear || rightIcon) && "has-right",
            error && "is-error",
            className,
          )}
          {...props}
        />

        {allowClear && hasValue && (
          <button
            type="button"
            onClick={() => onClear?.()}
            className="uiInput-clear"
            aria-label="Clear"
          >
            <X size={14} />
          </button>
        )}

        {!allowClear && rightIcon && (
          <span className="uiInput-icon uiInput-icon--right">{rightIcon}</span>
        )}
      </div>

      {error && <p className="uiField-error">{error}</p>}
    </div>
  );
}
